<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="600"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon
             v-on="on"
             @click.stop.prevent=""
      >
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-text class="text--primary">
        <div v-if="loadingDetalhes">
          <px-circular-loading/>
        </div>
        <template v-if="!loadingDetalhes && detalhes">
        <v-row class="title">
          <v-col cols="12">
            {{ detalhes.nome || transportador.pessoa.nome }}
          </v-col>
        </v-row>
        <div v-if="showScore && score">
          <v-skeleton-loader
            :loading="loading"
            max-width="150"
            type="text"
          >
            <px-show-avaliacao-icon-simple span-class="text--primary"
                                           :avaliacao="pontuacao"/>
            <v-icon class="ml-3 mr-1 mb-1">mdi-calculator</v-icon>
            <px-transportador-score :score="score"/>
          </v-skeleton-loader>
        </div>
        <v-row dense v-if="detalhes.nome">
          <v-col cols="12">
            <v-icon>mdi-account-tie</v-icon>
            <px-span-tooltip bottom
                             tooltip="Nome receita"
                             :text="transportador.pessoa.nome"/>
          </v-col>
        </v-row>
        <v-row class="">
          <v-col cols="12">
            <v-icon>mdi-domain</v-icon>
            {{ transportador.pessoa.cnpj | cnpj }}
            <px-regime-tributario :regime-tributario="transportador.pessoa.regimeTributario"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="7" v-if="detalhes && detalhes.emails && detalhes.emails.length">
            <template v-for="(email, index) in detalhes.emails">
              <div :key="index">
                <v-icon>
                  mdi-email
                </v-icon>
                {{ email }}
              </div>
            </template>
          </v-col>
          <v-col cols="12" sm="7" v-if="computedEmail">
            <v-icon>
              mdi-email
            </v-icon>
            {{ computedEmail }}
          </v-col>
          <v-col cols="12" sm="5"
                 v-if="detalhes
                    && detalhes.whatsapps
                    && detalhes.whatsapps.length">
            <template v-for="(whatsapp, index) in detalhes.whatsapps">
              <div :key="index">
                <v-icon>
                  mdi-whatsapp
                </v-icon>
                {{ formatPhone(whatsapp) }}
              </div>
            </template>
          </v-col>
          <v-col cols="12" sm="5" v-if="transportador.pessoa.telefone">
            <v-icon>mdi-phone</v-icon>
            {{ formatPhone(transportador.pessoa.telefone) }}
          </v-col>
        </v-row>
        <v-row v-if="transportador.site">
          <v-col cols="12">
            <v-icon>mdi-web</v-icon>
            {{ site }}
            <v-btn icon :href="site" target="_blank">
              <v-icon small>
                mdi-open-in-new
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="">
          <v-col cols="12">
            <v-icon>mdi-map-marker</v-icon>
            {{ endereco(transportador) }}
          </v-col>
        </v-row>
        </template>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import Vue from 'vue';
import { TipoFornecedor } from 'px-business-components';
import { computeEndereco } from '@/utils/endereco-utils';
import FornecedorService from '@/api/fornecedor-service';
import TransportadorService from './transportador-service';

export default {
  props: {
    icon: {
      type: String,
      default: 'mdi-chevron-down',
    },
    showScore: {
      type: Boolean,
      default: false,
    },
    transportador: Object,
  },
  data: () => ({
    menuOpened: false,
    loading: false,
    loadingDetalhes: false,
    score: null,
    detalhes: null,
  }),
  computed: {
    site() {
      if (!this.transportador.site) {
        return null;
      }
      if (this.transportador.site.includes('http://') || this.transportador.site.includes('https://')) {
        return this.transportador.site;
      }
      return `https://${this.transportador.site}`;
    },
    pontuacao() {
      if (!this.score) {
        return null;
      }
      return this.score.pontuacaoMedia;
    },
    computedEmail() {
      if (!this.detalhes) {
        return this.fornecedor.pessoa.email;
      }
      if (this.detalhes.user) {
        return this.detalhes.user.email;
      }
      return null;
    },
    fornecedor() {
      return this.detalhes ? this.detalhes.fornecedor : null;
    },
    endereco() {
      return fornecedor => computeEndereco(fornecedor.endereco);
    },
    formatPhone() {
      return phone => (this.isNacional() ? Vue.filter('phone')(phone) : phone);
    },
  },
  methods: {
    getScore() {
      this.loading = true;
      TransportadorService.getScore(this.transportador.id)
        .then(({ data }) => {
          this.score = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDetalhes() {
      this.loadingDetalhes = true;
      FornecedorService.getFornecedorDetalhes(this.transportador.id)
        .then(({ data }) => {
          this.detalhes = data;
        })
        .finally(() => {
          this.loadingDetalhes = false;
        });
    },
    isNacional() {
      return this.fornecedor.tipo === TipoFornecedor.keys.NACIONAL.key;
    },
  },
  watch: {
    menuOpened(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (this.menuOpened && this.showScore && !this.score) {
        this.getScore();
      }
      if (this.menuOpened && !this.detalhes) {
        this.getDetalhes();
      }
    },
  },
};
</script>
